import { useState } from "react"
import { Head, router } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { FormRow, FormSection } from "@/components/blocks/FormRows"
import { PageHeader } from "@/components/PageHeader"
import { Checkbox } from "@/components/ui/checkbox"

export default function AdminSettingsShow({ require_email_confirmation }: { require_email_confirmation: boolean }) {
  const description = "Site-wide switches for admins."
  // Local state so the box flips on click; the saved value replaces it on reload.
  const [requireConfirmation, setRequireConfirmation] = useState(require_email_confirmation)

  const save = (value: boolean) => {
    setRequireConfirmation(value)
    router.patch(
      "/admin/settings",
      { require_email_confirmation: value },
      {
        preserveScroll: true,
        onError: () => setRequireConfirmation(!value),
      },
    )
  }

  return (
    <>
      <Head title="Settings">
        <meta name="description" content={description} />
        <meta property="og:title" content="Settings" />
        <meta property="og:description" content={description} />
      </Head>
      <AdminShell>
        <PageHeader title="Settings" description={description} />
        <div className="mt-8">
          <FormSection title="Signup">
            <FormRow label="Email confirmation" htmlFor="require_email_confirmation">
              <label className="flex items-center gap-3 font-normal text-ink-body">
                <Checkbox
                  id="require_email_confirmation"
                  checked={requireConfirmation}
                  onChange={(e) => save(e.target.checked)}
                />
                Require new users to confirm their email
              </label>
              <p className="mt-3 text-sm/6 text-ink-muted">
                When on, people who sign up with a password must click a link we email them before they can sign in.
                When off, they go straight into the app. Admins are emailed whenever someone confirms.
              </p>
            </FormRow>
          </FormSection>
        </div>
      </AdminShell>
    </>
  )
}
